import { IContractAddress } from '../entities/IContractAddress';
import { ILeadLegalInfo } from '../entities/ILeadLegalInfo';
import { httpClient } from './helper/httpClient';

export interface IUpsertLeadLegalInfoParams {
  cpf?: string;
  rg?: string;
  profession?: string;
  maritalStatus?: string;
  nationality?: string;
  address?: IContractAddress | null;
}

class LeadLegalInfoService {
  getByLeadId(leadId: string): Promise<ILeadLegalInfo> {
    return httpClient.get<null, ILeadLegalInfo>(`leads/${leadId}/legal-info`);
  }

  upsert(
    leadId: string,
    data: IUpsertLeadLegalInfoParams,
  ): Promise<ILeadLegalInfo> {
    return httpClient.put<null, ILeadLegalInfo>(`leads/${leadId}/legal-info`, {
      ...data,
    });
  }
}

export default new LeadLegalInfoService();
